import { Navigate } from 'react-router-dom'
import { useSession } from '../lib/auth'
import { Loader2 } from 'lucide-react'

/**
 * Smart root redirect component
 *
 * Checks authentication state and redirects:
 * - Authenticated users → /dashboard
 * - Unauthenticated users → /sign-in
 *
 * Shows a loading spinner while checking session status.
 */
export function RootRedirect() {
  const { data: session, isPending } = useSession()

  if (isPending) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    )
  }

  if (session) {
    return <Navigate to="/dashboard" replace />
  }

  return <Navigate to="/sign-in" replace />
}
